<template>
  <Popup
    :show="props.modelValue"
    position="center"
    :close-on-click-overlay="false"
    :lock-scroll="true"
    :teleport="false"
    :z-index="2000"
    :style="{ background: 'transparent' }"
    class="mid-autumn-popup"
    @update:show="onUpdateShow"
  >
    <div class="dialog" :class="cssType">
      <div class="dialog-content" :class="[props.type, props.size]">
        <slot></slot>
        <div
          v-if="props.showClose"
          class="dialog-close"
          :class="props.type"
          @click="handleClose"
        ></div>
      </div>
    </div>
  </Popup>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import { Popup } from 'vant'
import { isMobile } from '@/utils'

const cssType = isMobile ? 'mobile' : 'pc'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  // validateUser | common | large
  type: {
    type: String,
    required: true,
  },
  showClose: {
    type: Boolean,
    default: true,
  },
  // normal | large
  size: {
    type: String,
    default: 'normal',
  },
})

const emit = defineEmits(['update:modelValue'])

const onUpdateShow = (value) => {
  emit('update:modelValue', value)
}

const handleClose = () => {
  emit('update:modelValue', false)
}
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>

<!--
  vant center popup 用 left:50% + translateX(-50%)，
  transform 前布局盒会超出视口右侧，移动端会出现横向滚动条。
-->
<style>
.mid-autumn-popup.van-popup--center {
  max-width: 100% !important;
}
</style>
